import { render, staticRenderFns } from "./agree-privacy-dialog.vue?vue&type=template&id=47980a8e&scoped=true&"
import script from "./agree-privacy-dialog.vue?vue&type=script&lang=js&"
export * from "./agree-privacy-dialog.vue?vue&type=script&lang=js&"
import style0 from "./agree-privacy-dialog.vue?vue&type=style&index=0&id=47980a8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47980a8e",
  null
  
)

export default component.exports